import React, { Component } from "react";

import { MaterialsContextProvider } from "./context/materials-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class BSMaterials extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <MaterialsContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </MaterialsContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default BSMaterials;
